import React from 'react';
import { Link } from 'react-router-dom';
import { getWordSets } from '../data';
import { useTranslation } from '../hooks/useTranslation';
import './Home.css';

function Home() {
  const { t } = useTranslation();
  const wordSets = getWordSets(t);

  return (
    <div className="home-container">
      <header className="home-header">
        <h1 className="home-title">{t('app.title')}</h1>
        <p className="home-subtitle">{t('app.subtitle')}</p>
        <Link to="/settings" className="settings-link">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M12 1v6m0 6v6m11-11h-6m-6 0H1m16.24-6.36l-4.24 4.24m-6.36 6.36l-4.24 4.24m12.72 0l-4.24-4.24M7.76 7.76L3.52 3.52"></path>
          </svg>
        </Link>
      </header>

      <main className="home-main">
        {wordSets.map((category, categoryIndex) => (
          <section key={categoryIndex} className="category-section">
            <h2 className="category-title">{category.category}</h2>
            <div className="word-sets-grid">
              {category.sets.map((set) => (
                <Link 
                  key={set.id} 
                  to={`/typing/${set.id}`} 
                  className="word-set-card"
                  style={set.image ? {
                    backgroundImage: `linear-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.9)), url(${set.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                  } : {}}
                >
                  <div className="set-icon">{set.icon}</div>
                  <h3 className="set-name">{set.name}</h3>
                  <p className="set-description">{set.description}</p>
                  <div className="set-info">
                    <span className="set-level">{t('ui.level')} {set.level}</span>
                    <span className="set-word-count">{set.words.length}{t('ui.words_count')}</span>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </main>

      <footer className="home-footer">
        <p>{t('app.footer')}</p>
      </footer>
    </div>
  );
}

export default Home;